import {
  Box,
  Divider,
  FormControl,
  MenuItem,
  Select,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import React, { useRef, useState } from 'react'
import BreadcrumbNavigation from '../commoncomponents/breadcrumbnavigation'
import { useParams, useLocation } from 'react-router-dom'
import { useGetBomPartFullList, useInspectionSummary } from '../../hooks/task'
import PrintIcon from '../../assets/svg/PrintIcon'

const Selects = styled(Select)(() => ({
  borderRadius: '4px !important',
  '.MuiOutlinedInput-input': {
    padding: '8.5px 14px',
    fontSize: '14px !important'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#8A8A8'
  }
}))

const InspectionSummary = () => {
  const [first, setfirst] = useState('')
  const { id } = useParams()
  const { search } = useLocation()

  const initialBomPart = new URLSearchParams(search).get('bompartId') || ''
  const [selectedPart, setSelectedPart] = useState(initialBomPart)

  const { data: bomParts } = useGetBomPartFullList(id)

  const { data } = useInspectionSummary(
    { id, bomPartId: selectedPart },
    !!id && !!selectedPart
  )
  const componentRef = useRef()

  const tableData = data?.data || {}
  const jobCard = tableData?.jobCard || {}
  return (
    <React.Fragment>
      <Box className="production-team-head-overflow-hidden">
        <Box>
          <BreadcrumbNavigation
            pageTitle={'Inspection Summary'}
            setfirst={setfirst}
            first={first}
            backToLink="/job-card-department"
          />
        </Box>

<Box sx={{ padding: '16px 50px' }}>
  <Box
    sx={{
      padding: '30px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}
  >
    <Box sx={{ display: 'flex', gap: '75px' }}>
      <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
        <Box className="add-task-header">Job Card Name:</Box>
        <Box className="add-task-header-with-semibold">
          {jobCard?.name || '-'}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
        <Box className="add-task-header">Job Card Number:</Box>
        <Box className="add-task-header-with-semibold">
          {jobCard?.jobCardNumber || '-'}
        </Box>
      </Box>
    </Box>

    {/* Print box aligned to end */}
    <Box
      sx={{
        border: '1px solid #0160B9',
        borderRadius: '4px',
        padding: '6px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        color: '#0160B9',
        fontWeight: 500
      }}
      ref={componentRef} className="scrollable-div"
      onClick={() => window.print()}
    >
      Print <PrintIcon sx={{ fontSize: '18px' }} />
    </Box>
  </Box>

          <Divider
            sx={{
              marginTop: '5px !important',
              marginBottom: '35px !important'
            }}
          />

          <Box sx={{ width: '20%', paddingBottom: '15px' }}>
            <FormControl fullWidth>
              <Selects
                value={selectedPart}
                name="Select Part"
                onChange={(e) => setSelectedPart(e.target.value)}
              >
                {bomParts?.map((part) => (
                  <MenuItem key={part.id} value={part.id}>
                    {part.partName}
                  </MenuItem>
                ))}
              </Selects>
            </FormControl>
          </Box>

          {/* Show tables only when a part is selected */}
          {selectedPart && tableData?.departments?.length > 0 && (
            <>
              {/* Worker Inspection Table */}
              <Box>
                <Box className="title-typography">Worker Inspection</Box>
                <Box>
                  <TableContainer
                    sx={{
                      width: '45%',
                      height: '50%',
                      borderTopLeftRadius: '12px',
                      borderTopRightRadius: '12px',
                      overflow: 'hidden',
                      border: '1px solid #ccc'
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Task Name</TableCell>
                          <TableCell>Pass</TableCell>
                          <TableCell>Reject</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tableData?.departments?.filter(item => item?.isInspection === false)?.map((dept) => (
                          <React.Fragment key={dept.name}>
                            <TableRow>
                              <TableCell
                                colSpan={4}
                                style={{ fontWeight: 'bold' }}
                              >
                                {dept.name}
                              </TableCell>
                            </TableRow>
                            {dept.tasks?.map((task, index) => (
                              <TableRow key={task.id || index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{task.taskNickName}</TableCell>
                                <TableCell>{task.pass}</TableCell>
                                <TableCell>{task.reject}</TableCell>
                              </TableRow>
                            ))}
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>

              {/* Inspection Department Table */}
              <Box>
                <Box
                  className="title-typography"
                  sx={{ paddingTop: '50px', paddingBottom: '30px' }}
                >
                  Inspection Department
                </Box>
                <Box>
                  <TableContainer
                    sx={{
                      width: '45%',
                      height: '50%',
                      borderTopLeftRadius: '12px',
                      borderTopRightRadius: '12px',
                      overflow: 'hidden',
                      border: '1px solid #ccc'
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Department Name</TableCell>
                          <TableCell>Pass </TableCell>
                          <TableCell>Pass with deviation</TableCell>
                          <TableCell>Remark</TableCell>
                          <TableCell>Reject</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableData?.departments?.filter(item => item?.isInspection === true)?.flatMap((dept, deptIndex) =>
                          dept?.tasks?.map((task, taskIndex) => {
                            const isFirst = taskIndex === 0
                            const showDeptName =
                              isFirst ||
                              tableData.departments[deptIndex - 1]?.name !==
                                dept.name

                            return (
                              <TableRow
                                key={task.id || `${deptIndex}-${taskIndex}`}
                              >
                                <TableCell>{taskIndex + 1}</TableCell>
                                <TableCell>
                                  {showDeptName ? dept.name : ''}
                                </TableCell>
                                <TableCell>{task?.pass || '-'}</TableCell>
                                <TableCell>
                                  {task?.passWithDeviation || '-'}
                                </TableCell>
                                <TableCell>{task?.rework || '-'}</TableCell>
                                <TableCell>{task?.reject || '-'}</TableCell>
                              </TableRow>
                            )
                          })
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default InspectionSummary
